import React, {useState, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import Select, {ActionMeta} from 'react-select'

const MultiSelectDropdown = ({
  products,
  cuopon,
  stCuopon,
  name,
  notMulti,
}: {
  cuopon: any
  stCuopon: any
  products: any
  name: string
  notMulti?: any
}) => {
  const [selectedOptions, setSelectedOptions] = useState<any[]>([])
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      backgroundColor: 'var(--bs-body-bg)',
    }),
    option: (provided: any) => ({
      ...provided,
      backgroundColor: 'var(--bs-body-bg)',
      color: 'var(--bs-heading-color, inherit)',
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: 'var(--bs-body-bg)',
    }),
    multiValue: (provided: any) => ({
      ...provided,
      backgroundColor: 'var(--bs-app-bg-color)',
      color: 'var(--bs-heading-color, inherit)',
    }),
    multiValueLabel: (provided: any) => ({
      ...provided,
      color: 'var(--bs-heading-color, inherit)',
    }),
  }
  const {t} = useTranslation()

  useEffect(() => {
    if (notMulti) {
    } else {
      stCuopon({...cuopon, [name]: selectedOptions.map((option) => option.value)})
    }
  }, [selectedOptions])

  const options = products.map((product: any) => ({
    value: product.id,
    label: product.name.en,
  }))
  const [isCome, setIscome] = useState(true)
  useEffect(() => {
    if (products.length > 0 && cuopon[name] && isCome && cuopon.id) {
      setIscome(false)
      const options = products
        .filter((item: any) => cuopon[name].includes(item.id))
        .map((item: any) => ({value: item.id, label: item.name.en}))
      console.log('options', selectedOptions)

      if (options.length > 0) {
        setSelectedOptions([...selectedOptions, ...options])
      }
    } else if (cuopon[name] && cuopon[name].length === 0) {
      setIscome(false)
    }
  }, [products, cuopon[name], cuopon.id])

  const handleChange = (selected: any, actionMeta: any) => {
    if (notMulti) {
      stCuopon({...cuopon, [name]: selected ? selected.value : null})
      setSelectedOptions(selected as any[])
    } else {
      setSelectedOptions(selected as any[])
    }
  }

  return (
    <Select
      isMulti={!notMulti}
      placeholder={t('select')}
      options={options}
      styles={customStyles}
      value={selectedOptions}
      onChange={handleChange}
    />
  )
}

export default MultiSelectDropdown
